import { Component, inject, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap/dropdown';
import { lastValueFrom } from 'rxjs';
import { ProfileService } from 'src/app/auth/services/profile.service';
import { IOrganization } from 'src/app/dashboards/models/spatial.models';
import { UnsModalService } from '../../modals/service/uns-modal.service';
import { ThemeService } from '../../services/theme/theme.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { UserIconComponent } from '../user-icon/user-icon.component';

@Component({
  selector: 'app-user-control',
  templateUrl: './user-control.component.html',
  styleUrl: './user-control.component.scss',
  imports: [UserIconComponent, SpinnerComponent, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu],
})
export class UserControlComponent {
  public userInfo = input<IUserInfo>();

  protected resettingPassword = signal(false);

  protected readonly themeService = inject(ThemeService);
  private readonly profileService = inject(ProfileService);
  private readonly modalService = inject(UnsModalService);

  protected async resetMyPassword(): Promise<void> {
    try {
      this.resettingPassword.set(true);
      await lastValueFrom(this.profileService.resetMyPassword());
      this.resettingPassword.set(false);
      this.modalService.openInfoModal(
        'Wachtwoord reset',
        'Je wachtwoord is gereset, je ontvangt nu een email met een tijdelijk wachtwoord, ' +
          'Deze dien je bij de volgende inlog poging te veranderen',
      );
    } catch (error) {
      this.resettingPassword.set(false);
      console.error(error);
    }
  }
}

export interface IUserInfo {
  initials: string;
  color: string;
  displayName: string;
  mail: string;
  isLocalAccount: boolean;
  currentOrganization: IOrganization | null;
}
